import { render, staticRenderFns } from "./configuration-di-readonly.vue?vue&type=template&id=3663cafe&scoped=true&lang=pug"
import script from "./configuration-di-readonly.vue?vue&type=script&lang=ts"
export * from "./configuration-di-readonly.vue?vue&type=script&lang=ts"
import style0 from "./configuration-di-readonly.vue?vue&type=style&index=0&id=3663cafe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3663cafe",
  null
  
)

export default component.exports